// extracted by mini-css-extract-plugin
module.exports = {"directions":"_1j8Tn"};